import { MarketingLayout } from '@ui/layout/MarketingLayout'
import type { MarketingLayoutProps } from '@ui/layout/MarketingLayout'

import { SIGN_UP_HREF } from '@web-app/utils/auth/constants'

// The app's only door to the shared layout (lint-enforced): every Get Started under it targets the landing form.
export function WebMarketingLayout(
  props: Omit<MarketingLayoutProps, 'signUpHref'>,
) {
  return <MarketingLayout {...props} signUpHref={SIGN_UP_HREF} />
}
